import { deleteRequest, getRequest, postRequest } from "../apiHelper";

//POST REQUEST
export const updatePassword = postRequest("admin/changepassword", "changepassword");
export const signinUser = postRequest("admin/signin/", "signin");
export const userLogout = postRequest("admin/signout/", "signout");
export const addFished = postRequest("admin/addFishEd/", "addFishEd");
export const editFishEd = postRequest("admin/editFishEd/", "editFishEd");
export const addSpecies = postRequest("admin/addSpecies/", "addSpecies");
export const addSeason = postRequest("admin/addSeason/", "addSeason");
export const editSeason = postRequest("admin/editSeason/", "editSeason");
export const editSpecie = postRequest("admin/editSpecie/", "editSpecie");
export const addPointTable = postRequest("admin/addPointTable/", "addPointTable");
export const editPoints = postRequest("admin/editPoints/", "editPoints");
export const addLake = postRequest("admin/addLake/", "addLake");
export const editLake = postRequest("admin/editLake/", "editLake");
export const updateTcpp = postRequest("admin/TcPp/", "content");
export const sendAnnouncement = postRequest("admin/sendAnnouncement/", "sendAnnouncement");

//GET REQUEST
export const dashboard = getRequest("admin/dashboard/", "dashboard");
export const getFished = getRequest("admin/getFished/", "getFished");
export const recentLakes = getRequest("admin/recentLakes/", "recentLakes");
export const getAllUsers = getRequest("admin/getAllUsers/", "getAllUsers");
export const getSpecies = getRequest("admin/getSpecies/", "getSpecies");
export const getSpeciePoints = getRequest("admin/getSpeciePoints/", "getSpeciePoints");
export const getAllPointTable = getRequest("admin/getAllPointTable/", "getAllPointTable");
export const getAllLakes = getRequest("admin/getLakes/", "getLakes");
export const blockUnblock = getRequest("admin/blockUnblock/", "blockUnblock");
export const TcPp = getRequest("api/getTcPp/", "getTcPp");
export const getAllSeason = getRequest("admin/getAllSeason/", "getAllSeason");
export const getAllAnnouncements = getRequest("admin/getAllAnnouncements/", "getAllAnnouncements");
export const getSeasonRankings = getRequest("admin/getSeasonRankings/", "getSeasonRankings");
export const getStats = getRequest("admin/getStats/", "getStats");
export const getAllPosts = getRequest("admin/getAllPosts/", "getAllPosts");

//DELETE REQUEST
export const deleteFished = deleteRequest("admin/deleteFished/", "deleteFished");
export const deleteSpecie = deleteRequest("admin/deleteSpecie/", "deleteSpecie");
export const deleteSeason = deleteRequest("admin/deleteSeason/", "deleteSeason");
export const deletePoints = deleteRequest("admin/deletePoints/", "deletePoints");
export const deleteLake = deleteRequest("admin/deleteLake/", "deleteLake");
export const deleteAccount = deleteRequest("admin/deleteAccount/", "deleteAccount");
export const deleteAnnouncement = deleteRequest("admin/deleteAnnouncement/", "deleteAnnouncement");
export const deletePost = deleteRequest("admin/deletePost/", "deletePost");
